import { RootState } from "../store";

export const getSupportEmail = (state: RootState): string =>
    state.contactsReducer.supportContact.email;
